import { jsx as r } from "react/jsx-runtime";
const t = () => /* @__PURE__ */ r(
  "path",
  {
    d: "M8.0625 6C8.0625 5.44772 8.51022 5 9.0625 5H18C18.5523 5 19 5.44772 19 6V14.9375C19 15.4898 18.5523 15.9375 18 15.9375C17.4477 15.9375 17 15.4898 17 14.9375V8.41421L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L15.5858 7H9.0625C8.51022 7 8.0625 6.55228 8.0625 6Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }
);
export {
  t as default
};
